// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.loggedIn[data-v-066dfd23],.loggedOut[data-v-066dfd23] { background-color: rgb(216, 175, 39) !important; color: white;\n}\n.started[data-v-066dfd23],.passed[data-v-066dfd23] { background-color: grey !important; color: white;\n}\n.completed[data-v-066dfd23] { background-color: rgb(76, 175, 88) !important; color: white;\n}\n.survey[data-v-066dfd23] { background-color: rgb(81, 173, 216) !important; color: white;\n}\r\n", ""]);
// Exports
module.exports = exports;
